import React, { Component } from 'react';
import Peer, { RoomData } from 'skyway-js';
import './App.css';

export default class App extends Component {
  skyway_api_key: string;
  peer: any;
  room: any;
  state = {
    myid: '',
    name: '',
    log: Array(0).fill('')
  }
  constructor(props: any) {
    super(props);
    this.skyway_api_key = process.env.REACT_APP_SKYWAY_API_KEY || '';

    this.peer = new Peer({
      key: this.skyway_api_key,
      debug: 3
    });
    this.peer.on('open', (myId: any) => {
      console.log(`My Peer ID: ${myId}`);
      this.setState({ myid: myId });
      this.room = this.peer.joinRoom('joya', {
        mode: 'mesh'
      });
      this.room.on('data', (_data: RoomData) => {
        console.log(_data);
        let _log = [...this.state.log];
        if (_data.data === '') {
          _log.push(_data.src);
        } else {
          _log.push(_data.data);
        }
        this.setState({ log: _log });
        this.playSound();
      });
    });
    this.peer.on('error', (err: any) => {
      console.error(err);
    });
  }
  playSound() {
    console.log('sound');
    const sound = new Audio('sound.mp3');
    sound.play();
  }

  render() {
    return (<div className="App">
      <img src='kane.png' alt='kane' onClick={() => {
        this.playSound();
        let { name, myid } = this.state;
        let _log = [...this.state.log];
        _log.push(name === '' ? myid : name);
        this.setState({ log: _log });
        this.room.send(name);
      }}></img>
      <div>
        <label>ユーザー名:<input type='text' onChange={e => this.setState({ name: e.target.value })}></input></label>
      </div>
      <div className='log'>
        {this.state.log.map((l, i) => <p key={i}>{l}さんが鐘を鳴らしました</p>)}
      </div>
    </div>);
  }
}